import React from "react";
import { TextField } from "formik-material-ui";
import { Field } from "formik";

const MylocTextField = props => {
  return <Field component={TextField} margin="normal" variant="outlined" {...props} />;
};

export default MylocTextField;
